import { replaceTokensInString } from '@app/utils';
import { headlessLinks } from '@app/constants/links';
const catCorp = 'catcorp';

export const getLocale = seoURL => {
  const locale = seoURL?.substring(0, seoURL.indexOf('/', 1));
  return locale;
};

export const dealersHeadlessTermsConditionsURL = seoURL => {
  return replaceTokensInString(
    headlessLinks.HEADLESS_TERMS_CONDITIONS_PAGE_URL,
    seoURL
  );
};

export const getCatCorpUrl = seoURL => {
  const locale = getLocale(seoURL);
  return `${locale}/${catCorp}`;
};

export const dealersHeadlessPrivacyPolicy = seoURL => {
  const privacyPolicyUrl = replaceTokensInString(
    headlessLinks.HEADLESS_PRIVACY_POLICY_URL,
    seoURL
  );
  return privacyPolicyUrl;
};

export const termsOfUseHeadlessURL = (
  seoURL,
  catLegalTermsFlagValue = false
) => {
  const legalTermsUrl = catLegalTermsFlagValue
    ? headlessLinks.HEADLESS_CAT_LEGAL_TERMS_LINK
    : headlessLinks.HEADLESS_TERMS_OF_USE_URL;
  const catCorpURL = getCatCorpUrl(seoURL);
  const termsOfUseUrl = replaceTokensInString(legalTermsUrl, catCorpURL);
  return termsOfUseUrl;
};

export const privacyNoticeHeadlessURL = (
  seoURL,
  catLegalTermsFlagValue = false
) => {
  const privactNoticeURL = catLegalTermsFlagValue
    ? headlessLinks.HEADLESS_CAT_PRIVACY_LINK
    : headlessLinks.HEADLESS_PRIVACY_NOTICE_URL;
  const catCorpURL = getCatCorpUrl(seoURL);
  const privacyNoticeUrl = replaceTokensInString(privactNoticeURL, catCorpURL);
  return privacyNoticeUrl;
};

export const getConsentTemplate = (
  isPCCShowDealerTerms,
  getEspotContent,
  t,
  ESPOT_NAME
) => {
  if (isPCCShowDealerTerms) {
    const espotContent = getEspotContent(ESPOT_NAME);
    const espotHtml =
      espotContent?.contents?.length > 0 ? espotContent?.contents[0]?.html : '';
    return espotHtml;
  } else {
    return t('UR_CAT_ACCEPT_TERMS');
  }
};
